import { useEffect, useRef } from 'react';
import './Intro.css';

function Intro() {
  const iframeRef = useRef(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && iframeRef.current) {
          iframeRef.current.src =
            'https://www.youtube.com/embed/fsR_DnTD2BI?autoplay=1&mute=1&rel=0&modestbranding=1&controls=1';
        }
      },
      { threshold: 0.4 }
    );

    const section = sectionRef.current;
    if (section) observer.observe(section);

    return () => {
      if (section) observer.unobserve(section);
    };
  }, []);

  return (
    <section id="restaurant" className="intro" ref={sectionRef}>
      <div className="intro__inner">
        <span className="intro__label">Willkommen</span>
        <h2 className="intro__heading">
          Wer hier nicht glücklich wird, wird es nirgendwo!
        </h2>
        <div className="intro__divider" />
        <div className="intro__video-wrap">
          <iframe
            ref={iframeRef}
            className="intro__video"
            src=""
            title="Rocaille"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
          />
        </div>
        <div className="intro__mobile-divider" />
      </div>
    </section>
  );
}

export default Intro;
